import { render } from "./InventoryItemWebsiteSpecs.vue?vue&type=template&id=7214cd16&scoped=true"
import script from "./InventoryItemWebsiteSpecs.vue?vue&type=script&lang=js"
export * from "./InventoryItemWebsiteSpecs.vue?vue&type=script&lang=js"

import "./InventoryItemWebsiteSpecs.vue?vue&type=style&index=0&id=7214cd16&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7214cd16"]])

export default __exports__